export * from './GalleryPage';

import { GalleryPage } from './GalleryPage';

export default GalleryPage;